import { RegExps } from '@constants/forms'
import { customizeYup } from '@shared/components/forms/shared/validation/customize-yup'
import { array, mixed, object, string } from 'yup'

customizeYup()

export const validationSchema = object().shape({
	participants: array(
		object().shape({
			fullname: string().nullable().required(),
			phone: string()
				.matches(RegExps.phone, {
					message: 'Указан неверный формат номера',
				})
				.required(),
		})
	).notRequired(),
})
